export const PUT_ALL_HOUSEHOLDS = 'PUT_ALL_HOUSEHOLDS';
export const PUT_ACTIVE_HOUSEHOLD_ADDRESS = 'PUT_ACTIVE_HOUSEHOLD_ADDRESS';
export const SET_HOUSEHOLDS_INITIALIZATION = 'SET_HOUSEHOLDS_INITIALIZATION';
export const PUT_HOUSEHOLD_METADATA = 'PUT_HOUSEHOLD_METADATA';
export const SET_LOADING = 'SET_LOADING';
